import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "app"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "balance-num" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_WalletDrawer = _resolveComponent("WalletDrawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isInitialized)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "float-pill mono",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.walletOpen = true)),
          title: _ctx.connTitle
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["conn-dot", _ctx.arkStatus])
          }, null, 2),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formatSats(_ctx.walletBalance)), 1),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "balance-unit" }, "sats", -1))
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              onOpenWallet: _cache[1] || (_cache[1] = ($event: any) => (_ctx.walletOpen = true))
            }, null, 32))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    (_ctx.isInitialized && _ctx.$route.path === '/history')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: "/",
          class: "corner-link history-corner"
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" « play ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_WalletDrawer, {
      open: _ctx.walletOpen,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.walletOpen) = $event))
    }, null, 8, ["open"])
  ]))
}